import { RadioGroup, Typography } from '@mui/material';
import type { FC } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { VrsCallCommentsHelperText } from 'features/call/vrs-call-comments/components';
import { AbuseFormValue } from 'features/call/vrs-call-comments/enums';
import type { VrsCallCommentsAbuseFormControl } from 'features/call/vrs-call-comments/interfaces';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';
import { FormControlLabel, Radio } from 'features/ui/elements';

export const VrsCallCommentsAbuseWitnessControl: FC<
  VrsCallCommentsAbuseFormControl
> = ({ control }) => {
  const { t: ct } = useTranslation();
  const { t } = useTranslation('translation', {
    keyPrefix: 'abuseCommentText',
  });

  return (
    <>
      <Typography variant='subtitle2' color={theme.palette.grey[300]} mt={12}>
        {t('witnessTitle')}
      </Typography>
      <Controller
        control={control}
        name='witnessType'
        rules={{ required: true }}
        render={({ field: { ...args }, fieldState }) => (
          <>
            <RadioGroup {...args}>
              <RadioControlLabel
                value={AbuseFormValue.YES}
                label={ct(AbuseFormValue.YES)}
                control={<Radio />}
              />
              <RadioControlLabel
                value={AbuseFormValue.NO}
                label={ct(AbuseFormValue.NO)}
                control={<Radio />}
              />
            </RadioGroup>
            {fieldState.error && (
              <VrsCallCommentsHelperText>
                {t('witnessValidation')}
              </VrsCallCommentsHelperText>
            )}
          </>
        )}
      />
    </>
  );
};

const RadioControlLabel = styled(FormControlLabel)`
  margin-top: ${theme.spacing(4)};
`;
